@if (activitiesAcc$ | async; as activities) {
    @for (activity of activities; track activity.id; let index = $index) {
        <ng-template [ngTemplateOutlet]="templateRef"
                     [ngTemplateOutletContext]="{activity: activity, index: index}">
        </ng-template>
    }
    @if (activities.length === 0 && !isLoading && hasMorePageToLoad() === false) {
        {{ 'activity_search.no_lessons_found' | translate }}
    }
}
@if (isLoading || ((activitiesAcc$ | async).length === 0 && hasMorePageToLoad())) {
    <mat-spinner></mat-spinner>
}
